import styled from "styled-components";

/**
 * A simple round initials avatar used across the presentation mock-ups in
 * place of real user images. `$overlap` makes stacked avatars overlap (task
 * rows / cards), `$bordered` draws the paper-coloured ring that separates
 * overlapping avatars.
 */
export const RoundAvatar = styled.div<{
  $bg: string;
  $size?: number;
  $overlap?: boolean;
  $bordered?: boolean;
}>`
  width: ${(props) => props.$size ?? 28}px;
  height: ${(props) => props.$size ?? 28}px;
  border-radius: 50%;
  background-color: ${(props) => props.$bg};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${(props) => {
    const size = props.$size ?? 28;
    if (size <= 22) return 9;
    if (size <= 26) return 10;
    return 11;
  }}px;
  font-weight: 700;
  flex-shrink: 0;
  ${(props) =>
    props.$bordered === false
      ? ""
      : "border: 2px solid var(--page-paper-main);"}

  &:not(:first-child) {
    margin-left: ${(props) => (props.$overlap ? "-8px" : "0")};
  }
`;

RoundAvatar.displayName = "RoundAvatar";
